import { Outlet } from 'react-router-dom';

import { AuthProvider } from '@/app/providers';

/**
 * 모든 라우트에 공통 AuthProvider 적용(login / 일반 레이아웃 / callback 분기)
 */
export const RootOutlet: React.FC = () => {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
};
